module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('div', {
    staticClass: "element-label",
    staticStyle: {
      "height": "24px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n        "), _c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "20",
      "width": "2",
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('croppa', {
    staticStyle: {
      "border": "solid 2px #bbb",
      "border-radius": "0px"
    },
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "quality": 1,
      "placeholder": _vm.placeholder,
      "placeholder-font-size": 14,
      "file-size-limit": 100000,
      "placeholder-color": "#999",
      "disabled": false,
      "prevent-white-space": true,
      "canvas-color": "white",
      "show-remove-button": true,
      "remove-button-size": 20,
      "initial-image": _vm.element.value
    },
    on: {
      "file-size-exceed": _vm.fileSizeExceeded,
      "zoom": _vm.imageChanged,
      "move": _vm.imageChanged,
      "file-choose": _vm.imageChanged,
      "image-remove": _vm.imageRemoved
    },
    model: {
      value: (_vm.imageObject),
      callback: function($$v) {
        _vm.imageObject = $$v
      },
      expression: "imageObject"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f53a2fba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/controls/ImageControl.vue
// module id = 2668
// module chunks = 1